<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Change Username"
      :text="name + '\'s current username: ' + currentUsername"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                ref="username"
                v-model="username"
                v-validate="'required'"
                :error-messages="errors.collect('username')"
                data-vv-name="username"
                data-vv-as="current username"
                label="New Username"
                type="username"
                outlined         
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-col
        v-if="systemSettingValue === '1'"
        cols="12"
        class="px-6 pb-2 mt-n10"
      >
        <span class="dialog red--text">Kindly note that this username update will apply to this system and other integrated systems such as Workspace (HRM) / Lending Management System.</span>
      </v-col>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"  
          @click="setDialog(false)"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"      
          class="white--text px-10"        
          @click="submitForm"
        >
          Update Username
        </v-btn>
      </v-card-actions> 
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      user: {
        type: Object,
        default: null,
      },
      systemSettingValue: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        username: null,
      }
    },
    computed: {
      name () {
        return (this.user || {}).name || ''
      },
      currentUsername () {
        return (this.user || {}).username || ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) {
          this.$validator.reset()
          this.$resetData()
        }
      },
    },
    methods: { 
      toggleDialog () {
        this.username = this.currentUsername
        this.dialog = true
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.users().update(this.user.user_uid, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: this.name + '\'s username updated' })
                }
                this.dialog = false
              })
              .catch(err => {
                if (err.response.status === 422) {
                  this.$snack({ color: 'error', message: 'Duplicate entry of username' })
                  this.$scrollToFirstErrorInput()
                } else {
                  this.$snack({ color: 'error', message: 'Unable to update username' })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
   
      prepareFormData () {
        return {
          username: this.username,
        }
      },

      setDialog (status) {
        this.dialog = status
      },
    },
  }
</script>
